import { DifficultyCategory } from "./UserClimbingEvent";
import { Sex } from "./UserData";

export class ClimbingEventSimplifiedResults {
    constructor(
        public sex: Sex,
        public userSumOfPoints: Map<string, UserSumOfPoints> = new Map<string, UserSumOfPoints>(),
    ) {
    }
    toJSON(){
        return {
            sex: this.sex,
            userSumOfPoints: Object.fromEntries(this.userSumOfPoints),
        }
     }
}


export type UserSumOfPoints = {
    name?: string
    points: number
    zones?: number
    section: boolean
    userId: string
    difficultyCategory: DifficultyCategory,
    birthYear?: number,
    group: string,
    favoriteRoute?: number
}